module.exports = __webpack_public_path__ + "img/電気回路_6_4_1.4336fce2.png";